<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100 sdcCardItem">
        <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
            <div class="row pt-3">
                <div class="col-lg-2 col-md-12 col-xs-12 col-sm-6" *ngIf="btnExcluir">
                    <button mat-flat-button color="warn" (click)="delete()" class="sdcBtnSize" matTooltip="Excluir">
                        <i class="fa fa-minus fa-1x btnIcon"></i> Excluir
                    </button>
                </div>
            </div>
            <div class="row pt-3 mt-2">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Source</mat-label>
                        <input matInput id="txtSource" #txtSource maxlength="50" formControlName="source">
                        <mat-hint align="end">{{txtSource.value.length}} / 50</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.source)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Lote</mat-label>
                        <input matInput id="txtLote" #txtLote maxlength="10" formControlName="lote">
                        <mat-hint align="end">{{txtLote.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.lote)}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>